function toDate(value: Date | number | string): Date {
  return value instanceof Date ? value : new Date(value);
}

function isValidDate(d: Date): boolean {
  return !Number.isNaN(d.getTime());
}

/** Locale-neutral date: YYYY-MM-DD in the viewer's local timezone. */
export function formatDateIsoLocal(value: Date | number | string): string {
  const d = toDate(value);
  if (!isValidDate(d)) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

/** Locale-neutral date: YYYY-MM-DD in UTC (for filter snapshot epoch days). */
export function formatDateIsoUtcFromEpoch(epochSeconds: number): string {
  const d = new Date(epochSeconds * 1000);
  if (!isValidDate(d)) return "";
  const y = d.getUTCFullYear();
  const mo = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

export function formatDateShort(iso: string): string {
  return formatDateIsoLocal(iso);
}

export function formatDateTime(iso: string): string {
  return formatDateTimeIsoLocal(iso);
}

/** Locale-neutral table datetime: YYYY-MM-DD HH:mm in the viewer's local timezone. */
export function formatDateTimeIsoLocal(value: Date | number | string): string {
  const d = toDate(value);
  if (!isValidDate(d)) return "";
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const h = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${y}-${mo}-${day} ${h}:${min}`;
}
